import { LumdatalInit } from "../components/LumdatalInit";
import { RettmobilInit } from "../components/RettmobilInit";

export const DEFAULT_END_SCREEN = {
  title: "Vielen Dank!",
  messages: [
    "Ihre Teilnahme an der Auswertung hilft uns, Potenziale innerhalb der Feuerwehr zu erkennen und auszubauen.",
  ],
  closingMessage: "Sie können den Browser-Tab nun schließen.",
};

export interface SurveyTypeConfig {
  queryParam?: string;
  queryValue?: string;
  showProgressBar: boolean;
  endScreen: {
    title: string;
    messages: string[];
    closingMessage: string;
  };
  initComponent?: React.ComponentType<{ onAccepted: () => void }>;
}

export const surveyTypes: Record<string, SurveyTypeConfig> = {
  default: {
    showProgressBar: true,
    endScreen: DEFAULT_END_SCREEN,
  },
  lumdatal: {
    showProgressBar: false,
    initComponent: LumdatalInit,
    endScreen: DEFAULT_END_SCREEN,
    queryParam: "lumdatal",
    queryValue: "true",
  },
  rettmobil: {
    queryParam: "rettmobil",
    queryValue: "1",
    showProgressBar: false,
    initComponent: RettmobilInit,
    endScreen: {
      title: "Vielen Dank für Ihre Teilnahme.",
      messages: [
        "Bei Rückfragen wenden Sie sich bitte an info@FeuerwehrAgentur.de",
      ],
      closingMessage: "Sie können den Browser-Tab nun schließen.",
    },
  },
};
